export default __webpack_public_path__ + "static/media/logo3.233af925.png";